import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import PlanCheckoutForm from './PlanCheckoutForm';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY ?? '');

const PaymentContext = ({
  secretKey,
  updateUser,
  showPayButton = false,
}: {
  secretKey: string;
  updateUser?: boolean;
  showPayButton?: boolean;
}) => (
  <Elements
    stripe={stripePromise}
    options={{
      clientSecret: secretKey,
    }}
  >
    <PlanCheckoutForm updateUser={updateUser} showPayButton={showPayButton} />
  </Elements>
);

export default PaymentContext;
